import React from 'react';
import { Link, Stack, Typography } from '@mui/material';
import config from '../../config.js';

const { termsAndConditionsLink, privacyPolicyLink, companyName, helpLink } = config;

const footerLinks = [
  {
    name: 'Terms',
    href: termsAndConditionsLink,
    ariaLabel: 'Read our terms of use',
  },
  {
    name: 'Privacy Policy',
    href: privacyPolicyLink,
    ariaLabel: 'Read our privacy policy',
  },
  {
    name: 'Help',
    href: helpLink,
    ariaLabel: 'Read our Help Center articles',
  },
];

const FooterLinks = () =>
  footerLinks.map(({ name, href, ariaLabel }) => {
    if (!href) {
      return null;
    }

    return (
      <Link
        key={name}
        variant="caption"
        color="vpColors.greyDark"
        underline="hover"
        rel="noopener noreferrer"
        target="_blank"
        href={href}
        aria-label={ariaLabel}
      >
        {name}
      </Link>
    );
  });

const Footer = () => {
  return (
    <Stack
      sx={{ p: 8, pt: 4 }}
      flexWrap="wrap"
      gap="16px"
      direction="row"
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant="caption">© {new Date().getFullYear() + ' ' + companyName} </Typography>
      <FooterLinks />
    </Stack>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Mainfooter/Footer.js